// frontend/src/components/Footer.js
import React from 'react';
import './Footer.css';
import logo from '../assets/images/logo1.webp';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  // Define the contact details and links, consistent with ContactSection.js
  const fullAddress = "45 London Road, Santina Apartment";
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
  const phoneNumber = "+44 7436 592175";
  const whatsappMessage = "Hello, I have a question about your spices.";
  const whatsappLink = `https://wa.me/${phoneNumber.replace(/\s/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;
  const emailAddress = "thegreenpod.spices@gmail.com";
  const mailtoLink = `mailto:${emailAddress}`;

  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section about">
          <img src={logo} alt="Greenpod Spices Logo" className="footer-logo" />
          <p>
            Green Pod brings the heritage flavours of Kerala to UK homes.
We source directly from dedicated farmers, blend in small batches, and craft each pack with care.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/thegreenpod_uk/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#categories-section">Categories</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/#about-section">About Us</Link></li>
            <li><Link to="/#contact-section">Contact Us</Link></li>
            <li><Link to="/return-policy">Return Policy</Link></li>
            <li><Link to="/terms-and-privacy">Privacy & Terms</Link></li>
          </ul>
        </div>

        <div className="footer-section contact-info">
          <h3>Contact Info</h3>
          {/* The address is now a clickable link to a Google Map */}
          <p>
            <FaMapMarkerAlt />
            <a href={mapLink} target="_blank" rel="noopener noreferrer" className="contact-link">
              {fullAddress}
            </a>
          </p>
          {/* The phone number is now a clickable link to a WhatsApp chat */}
          <p>
            <FaPhone />
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="contact-link">
              {phoneNumber}
            </a>
          </p>
          {/* The email is now a clickable 'mailto' link */}
          <p>
            <FaEnvelope />
            <a href={mailtoLink} className="contact-link">
              {emailAddress}
            </a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Greenpod Spices. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
